import CategoryOverview from "./CategoryOverview";

/** /super_admin/contribution/contribution_history: totals by category. */
export default function Contribution_History() {
  return <CategoryOverview />;
}
